// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NewPlant, Plant, type PlantWireFormat } from '../Plant/Plant';
import { NewProduct, Product, type ProductWireFormat } from '../Product/Product';

export class ProjectConfigProduct {
  readonly product: Product;
  readonly quantity: string;
  readonly externalName: string | null;
  readonly usage: string | null;
  readonly location: Plant;

  constructor(data: { [key: string]: any } = {}) {
    this.product = NewProduct(data.product);
    this.quantity = data.quantity === undefined ? '0' : data.quantity;
    this.externalName = data.externalName === undefined ? null : data.externalName;
    this.usage = data.usage === undefined ? null : data.usage;
    this.location = NewPlant(data.location);
  }

  static zero(): ProjectConfigProduct {
    const zeroValues: ExcludeMethodsDeep<ProjectConfigProduct> = {
      product: Product.zero(),
      quantity: '0',
      externalName: null,
      usage: null,
      location: Plant.zero(),
    };
    return new ProjectConfigProduct(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectConfigProductWireFormat = {
  product: ProductWireFormat;
  quantity: string;
  externalName: string | null;
  usage: string | null;
  location: PlantWireFormat;
};

type NewProjectConfigProductProps = PartialDeep<ProjectConfigProduct, { recurseIntoArrays: true }>;
export const NewProjectConfigProduct: (
  props: NewProjectConfigProductProps,
) => ProjectConfigProduct = (props) => new ProjectConfigProduct(props);

type NewProjectConfigProductFromWireFormatProps = PartialDeep<
  ProjectConfigProductWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectConfigProductFromWireFormat: (
  props: NewProjectConfigProductFromWireFormatProps,
) => ProjectConfigProduct = (props) => new ProjectConfigProduct(props);
